/**
 * Encode filename for URL usage
 */
export function encodeImageSlug(pathname: string): string {
  const filename = pathname.split('/').pop() || pathname
  return encodeURIComponent(filename)
}

/**
 * Decode URL slug back to filename
 */
export function decodeImageSlug(slug: string): string {
  return decodeURIComponent(slug)
}

/**
 * Return image basename without extension from full pathname
 */
export function imageBaseName(pathname: string): string {
  const fileName = pathname.split('/').pop() || pathname
  return fileName.split('.').slice(0, -1).join('.') || fileName
}

/**
 * Check if two image paths match (handling encoding)
 */
export function isImageMatch(pathname: string, slug: string): boolean {
  const decodedSlug = decodeImageSlug(slug)
  return pathname === decodedSlug || pathname.endsWith(`/${decodedSlug}`)
}

/**
 * Build image delivery URL with optional variant size.
 */
export function imageUrl(pathname: string, size: 'full' | 'thumb' = 'full'): string {
  const encodedPath = pathname
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/')

  if (size === 'thumb') {
    return `/images/${encodedPath}?size=thumb`
  }

  return `/images/${encodedPath}`
}
